'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTableLayoutIds = exports.injectRemainingDimensionsInLayout = exports.getLayoutCombinations = exports.getLayoutDimsIds = exports.injectCombinationsInLayout = exports.getCombinationLevelCompatibility = exports.injectCombination = exports.getLayoutRelationships = exports.getLayoutLevelRelationship = exports.indexCombsRelationships = exports.getCombinationsNotInLayout = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCombinationsNotInLayout = exports.getCombinationsNotInLayout = function getCombinationsNotInLayout(combinations, layoutIds) {
  var _layoutIds$header = layoutIds.header,
      header = _layoutIds$header === undefined ? [] : _layoutIds$header,
      _layoutIds$sections = layoutIds.sections,
      sections = _layoutIds$sections === undefined ? [] : _layoutIds$sections,
      _layoutIds$rows = layoutIds.rows,
      rows = _layoutIds$rows === undefined ? [] : _layoutIds$rows;

  var idsInLayout = new _set2.default([].concat((0, _toConsumableArray3.default)(header), (0, _toConsumableArray3.default)(sections), (0, _toConsumableArray3.default)(rows)));
  return R.reject(function (comb) {
    return idsInLayout.has(comb.id);
  }, combinations);
};

var indexCombsRelationships = exports.indexCombsRelationships = function indexCombsRelationships(combinations) {
  return R.reduce(function (acc, comb) {
    var id = comb.id,
        _comb$relationship = comb.relationship,
        relationship = _comb$relationship === undefined ? [] : _comb$relationship;

    return R.assoc(id, relationship, acc);
  }, {}, combinations);
};

var getLayoutLevelRelationship = exports.getLayoutLevelRelationship = function getLayoutLevelRelationship(indexedRelationships) {
  return function (ids) {
    return R.reduce(function (acc, id) {
      if (R.has(id, indexedRelationships)) {
        return R.concat(acc, R.prop(id, indexedRelationships));
      }
      return R.append(id, acc);
    }, [], ids);
  };
};

var getLayoutRelationships = exports.getLayoutRelationships = function getLayoutRelationships(indexedRelationships, layoutIds) {
  return R.map(getLayoutLevelRelationship(indexedRelationships), layoutIds);
};

var injectCombination = exports.injectCombination = function injectCombination(combination) {
  return function (ids) {
    var id = combination.id,
        _combination$concepts = combination.concepts,
        concepts = _combination$concepts === undefined ? [] : _combination$concepts;

    var conceptsSet = new _set2.default(concepts);
    var inject = true;
    var refined = R.reduce(function (acc, i) {
      if (!conceptsSet.has(i)) {
        return R.append(i, acc);
      }
      if (inject) {
        inject = false;
        return R.append(id, acc);
      }
      return acc;
    }, [], ids);
    return inject ? R.append(id, refined) : refined;
  };
};

var getCombinationLevelCompatibility = exports.getCombinationLevelCompatibility = function getCombinationLevelCompatibility(layoutRelationships, combination) {
  var _combination$relation = combination.relationship,
      relationship = _combination$relation === undefined ? [] : _combination$relation;

  var idsInHeaderSet = new _set2.default(layoutRelationships.header);
  var idsInSectionsSet = new _set2.default(layoutRelationships.sections);
  var idsInRowsSet = new _set2.default(layoutRelationships.rows);

  var _R$partition = R.partition(function (i) {
    return idsInHeaderSet.has(i);
  }, relationship),
      _R$partition2 = (0, _slicedToArray3.default)(_R$partition, 2),
      idsInHeader = _R$partition2[0],
      rest = _R$partition2[1];

  var _R$reduce = R.reduce(function (_acc, id) {
    if (idsInSectionsSet.has(id)) return R.over(R.lensIndex(0), R.append(id), _acc);
    if (idsInRowsSet.has(id)) return R.over(R.lensIndex(1), R.append(id), _acc);
    return R.over(R.lensIndex(2), R.append(id), _acc);
  }, [[], [], []], rest),
      _R$reduce2 = (0, _slicedToArray3.default)(_R$reduce, 2),
      idsInSections = _R$reduce2[0],
      idsInRows = _R$reduce2[1];

  if (!R.isEmpty(idsInHeader) && R.isEmpty(idsInSections) && R.isEmpty(idsInRows)) {
    return 'header';
  }
  if (!R.isEmpty(idsInHeader)) {
    return null;
  }
  if (!R.isEmpty(idsInSections) && R.isEmpty(idsInRows)) {
    return 'sections';
  }
  if (!R.isEmpty(idsInRows)) {
    return 'rows';
  }
  return 'blank';
};

var filterLayoutIds = function filterLayoutIds(indexedCombinations, layoutDimsIds, obsAttributes) {
  return function (layoutIds) {
    var layoutConcepts = R.map(R.reduce(function (acc, id) {
      if (R.has(id, indexedCombinations)) {
        return R.concat(acc, R.path([id, 'concepts'], indexedCombinations));
      }
      return R.append(id, acc);
    }, []), layoutIds);

    return R.mapObjIndexed(function (ids, level) {
      return R.filter(function (id) {
        if (id === 'OBS_ATTRIBUTES') {
          return !R.isEmpty(obsAttributes);
        }
        if (R.has(id, indexedCombinations)) {
          var comb = R.prop(id, indexedCombinations);
          var dims = R.filter(function (i) {
            return layoutDimsIds.has(i);
          }, comb.concepts);
          if (!R.isEmpty(dims)) {
            return true;
          }
          var oppositeIds = level === 'header' ? R.concat(R.prop('sections', layoutConcepts), R.prop('rows', layoutConcepts)) : R.prop('header', layoutConcepts);
          return R.isEmpty(R.intersection(comb.relationship, oppositeIds));
        }
        return layoutDimsIds.has(id);
      }, ids);
    }, layoutIds);
  };
};

var injectCombinationsInLayout = exports.injectCombinationsInLayout = function injectCombinationsInLayout(combinations, layoutIds) {
  var defaultLayoutIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var notInLayoutCombs = getCombinationsNotInLayout(combinations, layoutIds);
  if (R.isEmpty(notInLayoutCombs)) {
    return layoutIds;
  }
  var indexedCombsRelationships = indexCombsRelationships(combinations);
  var layoutRelationships = getLayoutRelationships(indexedCombsRelationships, layoutIds);
  var defaultLayoutRelationships = getLayoutRelationships(indexedCombsRelationships, defaultLayoutIds);
  return R.reduce(function (acc, comb) {
    var levelCompatibility = getCombinationLevelCompatibility(layoutRelationships, comb);
    if (R.isNil(levelCompatibility)) {
      return acc;
    }
    if (R.equals('blank', levelCompatibility)) {
      levelCompatibility = getCombinationLevelCompatibility(defaultLayoutRelationships, comb);
      if (R.isNil(levelCompatibility)) {
        return acc;
      }
      levelCompatibility = R.equals('blank', levelCompatibility) ? 'rows' : levelCompatibility;
    }

    layoutRelationships[levelCompatibility] = R.concat(layoutRelationships[levelCompatibility], comb.relationship);
    var ids = injectCombination(comb)(acc[levelCompatibility]);
    return R.assoc(levelCompatibility, ids)(acc);
  }, layoutIds, notInLayoutCombs);
};

var getLayoutDimsIds = exports.getLayoutDimsIds = function getLayoutDimsIds(dimensions) {
  return R.reduce(function (acc, d) {
    return d.header ? acc : acc.add(d.id);
  }, new _set2.default([]), dimensions);
};

var getLayoutCombinations = exports.getLayoutCombinations = function getLayoutCombinations(combinations, layoutDimsIds, attributes) {
  var indexedAttributes = R.indexBy(R.prop('id'), attributes);
  return R.reduce(function (acc, comb) {
    var _R$reduce3 = R.reduce(function (_acc, concept) {
      if (layoutDimsIds.has(concept)) {
        return R.map(R.append(concept), _acc);
      }
      if (R.has(concept, indexedAttributes)) {
        var attr = R.prop(concept, indexedAttributes);
        return attr.series ? (0, _extends4.default)({}, _acc, {
          relationship: R.concat(_acc.relationship, attr.relationship)
        }) : _acc;
      }
      return _acc;
    }, { layoutConcepts: [], relationship: [] }, comb.concepts || []),
        layoutConcepts = _R$reduce3.layoutConcepts,
        relationship = _R$reduce3.relationship;

    if (R.isEmpty(relationship)) {
      return acc;
    }
    return R.append((0, _extends4.default)({}, comb, { relationship: relationship, concepts: layoutConcepts }), acc);
  }, [], combinations);
};

var extractConcepts = function extractConcepts(ids, indexedCombinations, layoutDimsIds) {
  var entry = R.find(function (id) {
    if (R.has(id, indexedCombinations)) {
      var dimId = R.find(function (i) {
        return layoutDimsIds.has(i);
      }, R.pathOr([], [id, 'concepts'], indexedCombinations));
      return !R.isNil(dimId);
    }
    return true;
  }, ids);

  var getRelationship = function getRelationship(id) {
    if (R.has(id, indexedCombinations)) {
      return R.append(id, R.path([id, 'relationship'], indexedCombinations));
    }
    return [id];
  };
  var indexedRels = R.reduce(function (acc, id) {
    return R.assoc(id, getRelationship(id), acc);
  }, {}, ids);

  var relationship = [entry];
  while (!R.isEmpty(indexedRels)) {
    var related = R.pickBy(function (rels) {
      return !R.isEmpty(R.intersection(relationship, rels));
    }, indexedRels);
    if (R.isEmpty(related)) {
      break;
    }
    indexedRels = R.omit(R.keys(related), indexedRels);
    relationship = R.concat(relationship, R.unnest(R.values(related)));
  }
  var set = new _set2.default(relationship);
  return R.partition(function (id) {
    return set.has(id);
  }, ids);
};

var injectRemainingDimensionsInLayout = exports.injectRemainingDimensionsInLayout = function injectRemainingDimensionsInLayout(layoutIds, remainingDims, indexedCombinations, layoutDimsIds) {
  var _layout = layoutIds;
  var _remaining = remainingDims;

  var dimInRows = R.find(function (id) {
    if (layoutDimsIds.has(id)) {
      return true;
    }
    var dimId = R.find(function (i) {
      return layoutDimsIds.has(i);
    }, R.pathOr([], [id, 'concepts'], indexedCombinations));
    return !R.isNil(dimId);
  }, _layout.rows);

  if (R.isNil(dimInRows)) {
    if (R.isEmpty(_remaining)) {
      var toTakeIn = R.isEmpty(_layout.sections) ? 'header' : 'sections';

      var _extractConcepts = extractConcepts(R.prop(toTakeIn, _layout), indexedCombinations, layoutDimsIds),
          _extractConcepts2 = (0, _slicedToArray3.default)(_extractConcepts, 2),
          extracted = _extractConcepts2[0],
          remains = _extractConcepts2[1];

      _layout = (0, _extends4.default)({}, _layout, (0, _defineProperty3.default)({ rows: R.concat(_layout.rows, extracted) }, toTakeIn, remains));
    } else {
      _layout = R.over(R.lensProp('rows'), R.append(R.head(_remaining)))(_layout);
      _remaining = R.tail(_remaining);
    }
  }
  if (!R.isEmpty(_remaining)) {
    var hasNoHeader = R.isEmpty(_layout.header);
    var firstRemaining = R.head(_remaining);
    _remaining = hasNoHeader ? R.tail(_remaining) : _remaining;
    _layout = (0, _extends4.default)({}, _layout, {
      sections: R.concat(_layout.sections, _remaining),
      header: hasNoHeader ? [firstRemaining] : _layout.header
    });
  }
  return _layout;
};

var getTableLayoutIds = exports.getTableLayoutIds = function getTableLayoutIds(defaultLayoutIds, currentLayoutIds, dimensions, attributes, combinations) {
  var layoutDimsIds = getLayoutDimsIds(dimensions);
  var layoutCombinations = getLayoutCombinations(combinations, layoutDimsIds, attributes);
  var isBlank = R.pipe(R.values, R.all(R.isEmpty))(currentLayoutIds);

  var combinationsConcepts = R.pipe(R.pluck('_concepts'), R.unnest, function (ids) {
    return new _set2.default(ids);
  })(combinations);
  var obsAttributes = R.filter(function (a) {
    return a.series && R.isEmpty(a.relationship || []) && a.display && !combinationsConcepts.has(a);
  }, attributes);
  var indexedCombinations = R.indexBy(R.prop('id'), layoutCombinations);
  var filteredLayoutIds = filterLayoutIds(indexedCombinations, layoutDimsIds, obsAttributes)(isBlank ? defaultLayoutIds : currentLayoutIds);

  var layoutWithCombs = injectCombinationsInLayout(layoutCombinations, filteredLayoutIds, defaultLayoutIds);
  var layoutRelationshipsSets = R.map(R.pipe(function (ids) {
    return R.pick(ids, indexedCombinations);
  }, R.values, R.pluck('relationship'), R.unnest, function (i) {
    return new _set2.default(i);
  }), layoutWithCombs);
  var layoutConceptsSets = R.pipe(R.map(R.reduce(function (acc, id) {
    if (R.has(id, indexedCombinations)) {
      return R.concat(acc, R.path([id, 'concepts'], indexedCombinations));
    }
    return R.append(id, acc);
  }, [])), R.values, R.unnest, function (ids) {
    return new _set2.default(ids);
  })(layoutWithCombs);
  var defaultLayoutConceptsSets = R.map(function (ids) {
    return new _set2.default(ids);
  }, defaultLayoutIds);

  var _R$reduce4 = R.reduce(function (acc, dim) {
    if (layoutConceptsSets.has(dim.id) || dim.header) {
      return acc;
    }
    if (layoutRelationshipsSets.header.has(dim.id) || defaultLayoutConceptsSets.header.has(dim.id)) {
      return R.over(R.lensPath(['nextLayout', 'header']), R.append(dim.id))(acc);
    }
    if (layoutRelationshipsSets.sections.has(dim.id) || defaultLayoutConceptsSets.sections.has(dim.id)) {
      return R.over(R.lensPath(['nextLayout', 'sections']), R.append(dim.id))(acc);
    }
    if (layoutRelationshipsSets.rows.has(dim.id) || defaultLayoutConceptsSets.rows.has(dim.id)) {
      return R.over(R.lensPath(['nextLayout', 'rows']), R.append(dim.id))(acc);
    }
    if ((0, _dotstatsuiteSdmxjs.isTimePeriodDimension)(dim)) {
      return R.over(R.lensPath(['nextLayout', 'header']), R.append(dim.id))(acc);
    }
    if ((0, _dotstatsuiteSdmxjs.isRefAreaDimension)(dim)) {
      return R.over(R.lensPath(['nextLayout', 'rows']), R.append(dim.id))(acc);
    }
    return R.over(R.lensProp('remaining'), R.append(dim.id))(acc);
  }, { nextLayout: layoutWithCombs, remaining: [] }, dimensions),
      nextLayout = _R$reduce4.nextLayout,
      remaining = _R$reduce4.remaining;

  return injectRemainingDimensionsInLayout(nextLayout, remaining, indexedCombinations, layoutDimsIds);
};